export const GET_ACKO = 'Get ACKO app'

export const APP_COOKIE = 'webview'
export const APP_SOURCES = {
  ANDROID: 'android_app',
  IOS: 'ios_app',
}
